<template lang="pug">
.list-classification
  .group(v-for="(group, groupIndex) in filter" :key="groupIndex")
    .group-label {{ group.filter_name }}
    .group-items
      .item(v-for="(item, index) in group.filter_list"
        :key="item.id" :class="{'active': item.active}"
        @click="handleFilterItemClick(item, index, groupIndex)") {{ item.title }}
</template>

<script>
export default {
  name: "ListClassification",
  props: {
    filter: {
      type: Array,
    },
  },
  methods: {
    handleFilterItemClick(item, index, groupIndex) {
      if(!item.active) {
        this.$emit('change', {
          item,
          index,
          groupIndex,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.list-classification{
  .group{
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .group-label{
      flex: 0 0 60px;
      width: 60px;
      line-height: 24px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.39);
    }
    .group-items{
      display: flex;
      flex-wrap: wrap;
      .item{
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.59);
        margin: 0 12px;
        padding: 0 8px;
        border: 1px solid transparent;
        box-sizing: border-box;
        cursor: pointer;
        &.active{
          color: $main_color;
          border: 1px solid $main_color;
        }
      }
    }
  }
}
</style>
